export default {"src":"/_next/static/media/id.5dce2518.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};